import { createReducer } from '@ngrx/store';
import { SearchResultsState } from '@immosky/types';
import { immerOn } from 'ngrx-immer/store';
import {
  setInitialPageIndex,
  setPageIndex,
  setRealEstateObjects,
} from './search-results.actions';

let hasLoadedInitialPage = false;

export const initialState: SearchResultsState = {
  realEstateObjects: [],
  placeholderCards: [],
  initialPageIndex: 0,
  pageIndex: 0,
};

export const searchResultsReducer = createReducer(
  initialState,
  immerOn(setRealEstateObjects, (state, { objects }) => {
    state.realEstateObjects = objects;

    if (!hasLoadedInitialPage) {
      hasLoadedInitialPage = objects.length > 0;

      if (hasLoadedInitialPage) {
        state.pageIndex = state.initialPageIndex;
      }
    } else {
      state.pageIndex = 0;
    }
  }),
  immerOn(setInitialPageIndex, (state, { pageIndex }) => {
    state.initialPageIndex = pageIndex;
  }),
  immerOn(setPageIndex, (state, { pageIndex }) => {
    state.pageIndex = pageIndex;
  })
);
